/* School waitlist signup on coming-soon pages (collection.liquid + 404.liquid).
   Reveals an inline email form and subscribes the visitor to the Klaviyo
   School Waitlist list, stamping favorite_school with the school's display
   name so Klaviyo's School | {name} segments pick the profile up. */
class SchoolWaitlist extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.coming-soon__cta--toggle');
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="email"]');
    this.submitBtn = this.querySelector('.coming-soon__form-submit');
    this.msg = this.querySelector('.coming-soon__form-msg');
    if (!this.toggle || !this.form || !this.input || !this.submitBtn) return;

    this.toggle.addEventListener('click', () => {
      this.toggle.hidden = true;
      this.form.hidden = false;
      this.input.focus();
    });
    this.form.addEventListener('submit', (e) => this.onSubmit(e));
  }

  showMessage(text, isError) {
    this.msg.textContent = text;
    this.msg.classList.toggle('coming-soon__form-msg--error', !!isError);
    this.msg.hidden = false;
  }

  onSubmit(e) {
    e.preventDefault();
    var email = this.input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.showMessage('Please enter a valid email address.', true);
      this.input.focus();
      return;
    }
    this.msg.hidden = true;
    this.submitBtn.disabled = true;
    this.submitBtn.textContent = 'Submitting...';

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Coming Soon Page',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { favorite_school: this.dataset.schoolName }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: this.dataset.listId } }
        }
      }
    };

    fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' +
        encodeURIComponent(this.dataset.companyId),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error('Klaviyo subscribe failed: HTTP ' + res.status);
        var success = document.createElement('p');
        success.className = 'coming-soon__form-success';
        success.setAttribute('role', 'status');
        success.textContent =
          "Thank you! We'll notify you once " + this.dataset.schoolName + ' drops.';
        this.form.replaceWith(success);
      })
      .catch(() => {
        this.showMessage('Something went wrong. Please try again in a moment.', true);
        this.submitBtn.disabled = false;
        this.submitBtn.textContent = 'Notify Me';
      });
  }
}
if (!customElements.get('school-waitlist')) {
  customElements.define('school-waitlist', SchoolWaitlist);
}
